import React from 'react'
import { Link } from 'react-router-dom'

import direitoPenal from 'assets/images/direito-penal.jpg'
import direitoCivil from 'assets/images/direito-civil.jpg'
import direitoTrabalhista from 'assets/images/direito-trabalhista.jpg'
import direitoEmpresarial from 'assets/images/direito-empresarial.jpg'
import direitoTributario from 'assets/images/direito-tributario.jpg'
import direitoFamiliar from 'assets/images/direito-familiar.jpg'
import recuperacaoCredito from 'assets/images/recuperacao-credito.jpg'

function Section() {
  const services = [
    { name: 'Direito Tributário', image: direitoTributario },
    { name: 'Direito Empresarial', image: direitoEmpresarial },
    { name: 'Recuperação de Crédito', image: recuperacaoCredito },
    { name: 'Direito Penal', image: direitoPenal },
    { name: 'Direito Civil', image: direitoCivil },
    { name: 'Direito da Família', image: direitoFamiliar },
    { name: 'Direito Trabalhista', image: direitoTrabalhista },
  ]

  const normalizeString = (str) =>
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase()

  return (
    <section className='bg-gray-100 py-12'>
      <div className='container mx-auto mt-24 w-11/12 px-6 md:w-10/12'>
        <div className='flex items-center gap-2 text-xl'>
          <Link to={'/'} className='transition-all duration-500 hover:text-blue'>
            Home
          </Link>
          <span>/</span>
          <Link to={'/contatos'} className='transition-all duration-500 hover:text-blue'>
            Serviços
          </Link>
        </div>

        <div className='text-center'>
          <h2 className='text-gray-800 mb-4 text-4xl font-bold uppercase'>Nossos Serviços</h2>
          <p className='text-gray-600 mx-auto max-w-2xl text-lg'>
            Profissionais experientes para atender suas necessidades jurídicas com excelência.
          </p>
        </div>

        <div className='mt-10 grid grid-cols-1 gap-8 md:grid-cols-2'>
          {services.map((service, index) => (
            <Link to={`/servico/${normalizeString(service.name)}`} key={index} className='group'>
              <div className='flex flex-col items-center overflow-hidden transition-all duration-500 hover:scale-105 hover:shadow-xl md:flex-row'>
                <figure className='h-64 w-full md:w-1/2'>
                  <img src={service.image} alt={service.name} className='h-full w-full object-cover' />
                </figure>
                <figcaption className='p-6 text-center md:text-left'>
                  <h3 className='text-gray-800 group-hover:text-blue-600 text-xl font-semibold'>{service.name}</h3>
                  <p className='text-gray-600 mt-2'>
                    Especialistas em {service.name.toLowerCase()}, prontos para auxiliar com profissionalismo e
                    dedicação.
                  </p>
                </figcaption>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Section
